import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Menu, MenuItem, IconButton } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";

export default function ProfileMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      label: "Settings",
      onClick: handleClose,
    },
    {
      label: "Your Orders",
      onClick: handleClose,
    },
    {
      label: "Your Wishlist",
      link: "/wishlist",
      onClick: handleClose,
    },
  ];

  if (isAuthenticated) {
    menuItems.unshift(
      {
        label: "Your Account",
        link: "/myprofile",
      },
      {
        label: "Logout",
        link: "/logout",
      }
    );
  } else {
    menuItems.push({
      label: "Login",
      link: "/login",
    });
  }

  return (
    <div>
      <IconButton
        edge="end"
        aria-label="account of current user"
        aria-controls="profile-menu"
        aria-haspopup="true"
        onClick={handleClick}
        color="inherit"
        sx={{backgroundColor: "#ccc", borderRadius: "5px"}}
      >
        <AccountCircleIcon sx={{ color: "#1976D2" }} />
      </IconButton>
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={`profile-menu-item-${index}`}
            component={item.link ? Link : "div"}
            to={item.link}
            onClick={item.onClick}
            sx={{ "&:hover": { backgroundColor: "#f0f0f0" } }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
